import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { css } from '@emotion/react';

import { QueueProcessingGroupDetail } from 'features/queueProcessing/components/QueueProcessingGroupDetail';
import { QueueProcessingGroupList } from 'features/queueProcessing/components/QueueProcessingGroupList';
import { QueueProcessingSidebar } from 'features/queueProcessing/components/QueueProcessingSidebar';
import { QueueProcessingSection } from 'features/queueProcessing/models/enums/QueueProcessingSection';

const pageStyle = css({
    display: 'flex',
    height: '100vh',
    overflow: 'hidden',
    '& .page-content': {
        flex: 1,
        overflow: 'auto',
        backgroundColor: '#f5f5f5',
    },
});

export function QueueProcessingPage() {
    const [searchParams, setSearchParams] = useSearchParams();
    const tokenFromUrl = searchParams.get('groupToken');

    const [activeSection, setActiveSection] = useState<QueueProcessingSection>(
        tokenFromUrl !== null ? QueueProcessingSection.groupDetail : QueueProcessingSection.processes,
    );
    const [selectedGroupToken, setSelectedGroupToken] = useState<string | null>(tokenFromUrl);

    useEffect(() => {
        document.title = 'Queue Processing';
    }, []);

    function handleSelectGroup(token: string) {
        setSelectedGroupToken(token);
        setActiveSection(QueueProcessingSection.groupDetail);
        setSearchParams({ groupToken: token });
    }

    function handleBackToList() {
        setSelectedGroupToken(null);
        setActiveSection(QueueProcessingSection.processes);
        setSearchParams({});
    }

    function handleSectionChange(section: QueueProcessingSection) {
        if (section !== QueueProcessingSection.groupDetail) {
            setSelectedGroupToken(null);
            setSearchParams({});
        }
        setActiveSection(section);
    }

    return (
        <Box css={pageStyle}>
            <QueueProcessingSidebar
                activeSection={activeSection}
                onSectionChange={handleSectionChange}
            />
            <Box className="page-content">
                {activeSection === QueueProcessingSection.processes && (
                    <QueueProcessingGroupList onSelectGroup={handleSelectGroup} />
                )}
                {activeSection === QueueProcessingSection.groupDetail && selectedGroupToken !== null && (
                    <QueueProcessingGroupDetail groupToken={selectedGroupToken} onBack={handleBackToList} />
                )}
            </Box>
        </Box>
    );
}
